<template>
  <div id="page-container">
    <div id="app-container">
      <RouterView />
    </div>
  </div>
</template>

<script>
import { apiGetNavInfoList, apiGetNoticeList, apiGetPlatformConfigList } from './api/api';
import { useConfigStore } from '@/stores'

export default {
  name: 'App',
  data() {
    return {
      isLoading: false,
      configStore: useConfigStore(),
    };
  },
  created() {
    this.initAppDataInfo();
  },
  methods: {
    async initAppDataInfo() {
      if (this.isLoading) return;
      this.isLoading = true;

      apiGetNoticeList().then(response => { 
        const res = response.data;
        if (res.code === 200) {
          if(res.data){
            this.configStore.setNoticeList(res.data);
          }
        }
      });

      apiGetPlatformConfigList().then(response => { 
        const res = response.data;
        if (res.code === 200) {
          const data = res.data;
          if(data){
            this.configStore.setInfoList(data)

            const infos = new Map();
            const infoGroup = {}
            
            data.forEach(item => {
              infos.set(item.key, item)
              if(!infoGroup[item.group]){
                infoGroup[item.group] = []
              }
              infoGroup[item.group].push(item)
            });
            this.configStore.setInfoGroup(infoGroup)

            if(infos.has('logo')){
              this.configStore.setLogoUrl(infos.get('logo').data)
            }
            if(infos.has('bottom-bg')){
              this.configStore.setFooterImgUrl(infos.get('bottom-bg').data)
            }
            if(infos.has('index-redmodel-djks')){
              const info = infos.get('index-redmodel-djks');
              const data = {
                data: info.data,
                jumpTo: info.jumpTo == 'enable',
                jumpType: info.jumpType,
                url: info.url,
              }
              this.configStore.setIndexRedmodelDjks(data)
            }
            if(infos.has('index-redmodel-video')){
              const info = infos.get('index-redmodel-video');
              const data = {
                data: info.data,
                jumpTo: info.jumpTo == 'enable',
                jumpType: info.jumpType,
                url: info.url,
              }
              this.configStore.setIndexRedmodelVideo(data)
            }
            if(infos.has('pay-pdf-file')){ 
              const info = infos.get('pay-pdf-file');
              const data = {
                data: info.data,
                jumpTo: info.jumpTo == 'enable',
                jumpType: info.jumpType,
                url: info.url,
              }
              this.configStore.setPayPdfFile(data)
            }
            if(infos.has('home-365-img')){ 
              const info = infos.get('home-365-img');
              const data = {
                data: info.data,
                jumpTo: info.jumpTo == 'enable',
                jumpType: info.jumpType,
                url: info.url,
              }
              this.configStore.setHome365Img(data)
            }

            if(infoGroup['index-vip-pay']){
              this.configStore.setIndexVipCardItems(infoGroup['index-vip-pay'])
            }
            
          }
        }
      });

      apiGetNavInfoList().then(response => { 
        const res = response.data;
        if (res.code === 200) {
          if(res.data){
            this.configStore.setNavInfoList(res.data);
          }
        }
      });

    },
  }
}
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
}

#app {
  font-family: "Noto Sans SC", "Source Han Sans SC", "Source Han Sans CN", "思源黑体",
    -apple-system, "PingFang SC", "Microsoft YaHei", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#app-container {
  width: 100%;
  min-height: 100vh;
}
</style>
